// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Status buttons */

.beatloaderClass{

  display: flex;
  justify-content: space-around;
}

.applicationStatusCoverStatus {
  display: flex;
  align-items: center;
  justify-content: center;
}

.applicationStatusCoverStatus button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  margin: 5px;
}

.button-pending {
  background-color: green; /* Yellow */
}

.button-rejected {
  background-color: #ff4d4d; /* Red */
}

.button-incomplete {
  background-color: #ff8000; /* Orange */
}

.button-accepted {
  background-color: #4caf50; /* Green */
}

.button-settled {
  background-color: #008cba; /* Blue */
}

.CourseRegBtn {
  background-color: #36d7b7; /* Teal */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}




.HomeDashCoverWhole{
    /* background-color: red; */
    /* padding: 30px; */
   
    width: 100%;
   /* min-height: 1600px; */
}

.HomeDashCoverContainer{
    /* background-color: green; */
  width: 100%;  

  display: flex;
  /* flex-direction: column; */
  justify-content: space-around;
  margin-top: 30px;
  margin-bottom: 30px;
  

}

.resptCourse table{
  /* background-color: red; */
  /* width: 300px; */
  width: 100%;
  text-align: center;
  /* font-size: 7px; */
  /* font-size: 10px; */

}

.CourseRegBtn {
     
    background-color: green;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 2px;
    cursor: pointer;
   
     
}

.beatloader{
  /* background-color: red; */
  overflow: hidden;
}
.CourseRegBtn:hover {
     
    background-color: green;
    border: .1px solid black;
    padding: 5px 10px;
    border-radius: 2px;
    cursor: pointer;
   
     
}

.HomeDashCoverStudentNumber p{

  color: red;

}

.applicationStatusCoverStatus{
  /* background-color: #1565c0; */
  overflow: hidden;
}



.WalletCover{
  /* background-color:  red; */
  padding-left: 30px;
}
.txnHeading {
  background-color: gold;
  
}
.txnHeading h2{
  /* background-color: gray; */
  text-align: center;
  cursor: pointer;
  /* color: white; */
}
.txnHeadingSec{
  background-color: green;
  text-align: center;
  cursor: pointer;
}
.txnHeadingSec h2{
  color: white;
}

.HomeDashCover{
    max-width: 800px;
    /* background-color: red; */
}

.customdropdown{
  /* background-color: red;
  width:  100%; */

  padding: 0;
  margin: 0;
  width: 100%;
  border-radius: 3px;
  /* background-color: gray; */
  background-color: green;
  color: white;
  cursor: pointer;
  border: none;
}
/* .customdropdown select{
  background-color: red;


} */

.customdropdownCover{ 

  border: 1px solid gray;
  padding: 15px;
  /* background-color: gray; */
  background-color: green;
  border-radius: 3px;
  color: white;

}
/* .customdropdownCover select{ 

 background-color: red;
 border: none;

} */

.BtnSection{
    display: flex;
    /* border: 3px solid black; */
    margin-bottom: 30px;
}
.BtnSection h3{
  /* background-color: red; */
  font-size: 15px;
}

.BtndItem{
    flex: 1 1;
    text-align: center;
    border: 1px solid rgb(224, 223, 223);
    cursor: pointer;
    font-size: 15px;
}
.BtndItem p{
   padding-left: 30px;
}
.courseContentSection p{
    padding-left: 30px;
    /* background-color: red; */
}
.BtndItemActive{
    flex: 1 1;
    text-align: center;
   
    border: 1px solid #000;
    font-size: 15px;
    /* box-shadow:
      0 0 0 2px #fff, 
      0 0 0 4px #000; */
}
.BtndItem:hover{
    flex: 1 1;
    text-align: center;
   
    border: 1px solid #000;
    /* box-shadow:
      0 0 0 2px #fff, 
      0 0 0 4px #000; */
}

.courseContentSection{

    border: 1px solid rgb(224, 223, 223);
    min-width: 800px;
}



.ApplicationCardCover{
    /* background-color: red; */
    width: 100%;
    padding:  30px;
}
.ApplicationCardCover p{
     
   /* color: white; */
}
.ApplicationCardCover .TopHeading{
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
}

.applicationInputCover{
    border: 1px solid gray;
    padding: 15px;
}

.applicationInputActual{

    padding: 0;
    margin: 0;
    width: 100%;
    border-radius: 3px;
    /* background-color: gray; */
    background-color: green;
    cursor: pointer;
}
.applicationInputActual p{

    padding: 20px;
    margin: 0;
    color: white;
}

.ApplicationCTA button{
    width: 100%;
    /* background-color: green; */
    background-color: gold;
    padding: 20px 24px;
    font-weight: 900;
    cursor: pointer;
    border: none;
    border-radius: 3px;
}

.intakeDropDown{
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    /* overflow: hidden; */
}

.dropItems{
    
    position: absolute;
    top: 0;
    /* background-color: yellow; */
    height: 100%;
    width: 100%; 
    min-height: 400px;
    /* overflow: hidden; */
    /* max-width: 600px; */
    z-index: 1000;

}

.dropItem{

    background-color: red;
    margin-top: 20px;
    z-index: 2000;
}

.applyresContainer{
    /* background-color: RED; */
    padding: 5px;
}

.resAppCTA button{
        border: none;
        padding: 7px;
        border-radius: 3px;
        margin-top: 10px;
        background-color: #003300;
        color: white;
        cursor: pointer;
}

.applyresContainer{
    width: 100%;
    padding: 20px 5;
    border-bottom: 1px solid gray;
}

.applicationStatusCover{
    /* background-color: yellow; */
    display: flex;
    border-bottom: .5px solid gray;
    justify-content: space-between;
    padding-right: 20px;
    align-items: center;
}

.applicationStatusCoverCTA button{

        border: none;
        padding: 8px 12px;
        background-color: #003300;
        color: white;
        border-radius: 3px;

}
.applicationStatusCoverCTA button:hover{

        border: none;
        padding: 8px 12px;
        background-color: #119611;
        color: white;
        border-radius: 3px;
        zoom: 1.01;
        cursor: pointer;

}


/* DROPDOWN CSS */


/* ConfirmationCard.css */

.confirmation-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25); 
    z-index: 1;
    pointer-events: none; 
  }
  
  .confirmation-card {
    position: relative;
    z-index: 2;
    max-width: 400px;
    width: 100%;
    transition: top 0.5s ease-in-out;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    
  }
  
  .confirmation-card.visible {
    top: 30%;
  }
  
  .confirmation-card.hidden {
    top: -100vh;
  }
  
  .card {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 8px;
    position: relative;
  }

  .close-buttonSec {
  
    align-items: center;
  }
  .close-buttonSec .complete-payment-btn button{
    width: 300px;
    align-items: center;
    background-color: red;
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  
  .content {
    margin-top: 10px;
  }
  
  h2,
  h3 {
    color: #333333;
  }
  
  .status {
    font-weight: bold;
  }
  
  .next-steps h3{
    color: red;
  }
  .next-steps,
  .assistance {
    margin-top: 15px;
  }
  
  .complete-payment-btn {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .email {
    color: #1565c0;
  }


  @media screen and (max-width: 730px){       


          .resptCourse table{
            /* background-color: red; */
            width: 400px;
            /* width: 100%; */
            text-align: center;
            /* font-size: 7px; */
            font-size: 10px;
          
          }
          .resptCourse table button{

                 /* background-color: red; */
                 font-size: 10px;
          
          }

          .applyresContainer{
            width: 400px;
            padding: 20px 5;
            border-bottom: 1px solid gray;
        }
        

        .txnHeadingSec{
          width: 400px;
          background-color: green;
          text-align: center;
          cursor: pointer;
        }

        .txnHeading {
          background-color: gold;

          width: 400px;
          
        }

        
      .taglineHomeDashCover{
        /* background-color:  red; */
        padding-left: 10px;
      }
      .HomeDashCoverStudentNumber{
        /* background-color:  red; */
        padding-left: 10px;
      }


      .WalletCover{
        /* background-color:  red; */
        padding-left: 0;
      }

      .ApplicationCardCover{
        /* background-color: red; */
        width: 400px;
        padding:  30px;
    }

    .BtnSection h3{
      /* background-color: red; */
      font-size: 10px;
    }

  
  
   }
  
  /* post css */
  `, "",{"version":3,"sources":["webpack://./src/Pages/Home/Home.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;;EAEE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB,EAAE,WAAW;AACtC;;AAEA;EACE,yBAAyB,EAAE,QAAQ;AACrC;;AAEA;EACE,yBAAyB,EAAE,WAAW;AACxC;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA;EACE,yBAAyB,EAAE,SAAS;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;;;;AAKA;IACI,2BAA2B;IAC3B,mBAAmB;;IAEnB,WAAW;GACZ,wBAAwB;AAC3B;;AAEA;IACI,6BAA6B;EAC/B,WAAW;;EAEX,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;;;AAGrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;;AAEvB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;;;AAGnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;IAEI,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;;;AAGnB;;AAEA;;EAEE,UAAU;;AAEZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;;;AAIA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,sBAAsB;;AAExB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;EACE;iBACe;;EAEf,UAAU;EACV,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;;;;GAIG;;AAEH;;EAEE,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;;AAEd;AACA;;;;;GAKG;;AAEH;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,eAAe;AACnB;AACA;GACG,kBAAkB;AACrB;AACA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,SAAO;IACP,kBAAkB;;IAElB,sBAAsB;IACtB,eAAe;IACf;;uBAEmB;AACvB;AACA;IACI,SAAO;IACP,kBAAkB;;IAElB,sBAAsB;IACtB;;uBAEmB;AACvB;;AAEA;;IAEI,oCAAoC;IACpC,gBAAgB;AACpB;;;;AAIA;IACI,2BAA2B;IAC3B,WAAW;IACX,cAAc;AAClB;AACA;;GAEG,kBAAkB;AACrB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;;IAEI,UAAU;IACV,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,uBAAuB;IACvB,eAAe;AACnB;AACA;;IAEI,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;;AAEjB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;QACQ,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,yBAAyB;QACzB,YAAY;QACZ,eAAe;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;QAEQ,YAAY;QACZ,iBAAiB;QACjB,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;;AAE1B;AACA;;QAEQ,YAAY;QACZ,iBAAiB;QACjB,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,eAAe;;AAEvB;;;AAGA,iBAAiB;;;AAGjB,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,0CAA0C;;EAE5C;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;EACA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;;EAGA;;;UAGQ;YACE,2BAA2B;YAC3B,YAAY;YACZ,iBAAiB;YACjB,kBAAkB;YAClB,oBAAoB;YACpB,eAAe;;UAEjB;UACA;;iBAEO,2BAA2B;iBAC3B,eAAe;;UAEtB;;UAEA;YACE,YAAY;YACZ,eAAe;YACf,6BAA6B;QACjC;;;QAGA;UACE,YAAY;UACZ,uBAAuB;UACvB,kBAAkB;UAClB,eAAe;QACjB;;QAEA;UACE,sBAAsB;;UAEtB,YAAY;;QAEd;;;MAGF;QACE,4BAA4B;QAC5B,kBAAkB;MACpB;MACA;QACE,4BAA4B;QAC5B,kBAAkB;MACpB;;;MAGA;QACE,4BAA4B;QAC5B,eAAe;MACjB;;MAEA;QACE,2BAA2B;QAC3B,YAAY;QACZ,cAAc;IAClB;;IAEA;MACE,2BAA2B;MAC3B,eAAe;IACjB;;;;GAID;;EAED,aAAa","sourcesContent":["/* Status buttons */\n\n.beatloaderClass{\n\n  display: flex;\n  justify-content: space-around;\n}\n\n.applicationStatusCoverStatus {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.applicationStatusCoverStatus button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n  margin: 5px;\n}\n\n.button-pending {\n  background-color: green; /* Yellow */\n}\n\n.button-rejected {\n  background-color: #ff4d4d; /* Red */\n}\n\n.button-incomplete {\n  background-color: #ff8000; /* Orange */\n}\n\n.button-accepted {\n  background-color: #4caf50; /* Green */\n}\n\n.button-settled {\n  background-color: #008cba; /* Blue */\n}\n\n.CourseRegBtn {\n  background-color: #36d7b7; /* Teal */\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n\n\n\n.HomeDashCoverWhole{\n    /* background-color: red; */\n    /* padding: 30px; */\n   \n    width: 100%;\n   /* min-height: 1600px; */\n}\n\n.HomeDashCoverContainer{\n    /* background-color: green; */\n  width: 100%;  \n\n  display: flex;\n  /* flex-direction: column; */\n  justify-content: space-around;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  \n\n}\n\n.resptCourse table{\n  /* background-color: red; */\n  /* width: 300px; */\n  width: 100%;\n  text-align: center;\n  /* font-size: 7px; */\n  /* font-size: 10px; */\n\n}\n\n.CourseRegBtn {\n     \n    background-color: green;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 2px;\n    cursor: pointer;\n   \n     \n}\n\n.beatloader{\n  /* background-color: red; */\n  overflow: hidden;\n}\n.CourseRegBtn:hover {\n     \n    background-color: green;\n    border: .1px solid black;\n    padding: 5px 10px;\n    border-radius: 2px;\n    cursor: pointer;\n   \n     \n}\n\n.HomeDashCoverStudentNumber p{\n\n  color: red;\n\n}\n\n.applicationStatusCoverStatus{\n  /* background-color: #1565c0; */\n  overflow: hidden;\n}\n\n\n\n.WalletCover{\n  /* background-color:  red; */\n  padding-left: 30px;\n}\n.txnHeading {\n  background-color: gold;\n  \n}\n.txnHeading h2{\n  /* background-color: gray; */\n  text-align: center;\n  cursor: pointer;\n  /* color: white; */\n}\n.txnHeadingSec{\n  background-color: green;\n  text-align: center;\n  cursor: pointer;\n}\n.txnHeadingSec h2{\n  color: white;\n}\n\n.HomeDashCover{\n    max-width: 800px;\n    /* background-color: red; */\n}\n\n.customdropdown{\n  /* background-color: red;\n  width:  100%; */\n\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  border-radius: 3px;\n  /* background-color: gray; */\n  background-color: green;\n  color: white;\n  cursor: pointer;\n  border: none;\n}\n/* .customdropdown select{\n  background-color: red;\n\n\n} */\n\n.customdropdownCover{ \n\n  border: 1px solid gray;\n  padding: 15px;\n  /* background-color: gray; */\n  background-color: green;\n  border-radius: 3px;\n  color: white;\n\n}\n/* .customdropdownCover select{ \n\n background-color: red;\n border: none;\n\n} */\n\n.BtnSection{\n    display: flex;\n    /* border: 3px solid black; */\n    margin-bottom: 30px;\n}\n.BtnSection h3{\n  /* background-color: red; */\n  font-size: 15px;\n}\n\n.BtndItem{\n    flex: 1;\n    text-align: center;\n    border: 1px solid rgb(224, 223, 223);\n    cursor: pointer;\n    font-size: 15px;\n}\n.BtndItem p{\n   padding-left: 30px;\n}\n.courseContentSection p{\n    padding-left: 30px;\n    /* background-color: red; */\n}\n.BtndItemActive{\n    flex: 1;\n    text-align: center;\n   \n    border: 1px solid #000;\n    font-size: 15px;\n    /* box-shadow:\n      0 0 0 2px #fff, \n      0 0 0 4px #000; */\n}\n.BtndItem:hover{\n    flex: 1;\n    text-align: center;\n   \n    border: 1px solid #000;\n    /* box-shadow:\n      0 0 0 2px #fff, \n      0 0 0 4px #000; */\n}\n\n.courseContentSection{\n\n    border: 1px solid rgb(224, 223, 223);\n    min-width: 800px;\n}\n\n\n\n.ApplicationCardCover{\n    /* background-color: red; */\n    width: 100%;\n    padding:  30px;\n}\n.ApplicationCardCover p{\n     \n   /* color: white; */\n}\n.ApplicationCardCover .TopHeading{\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 10px;\n}\n\n.applicationInputCover{\n    border: 1px solid gray;\n    padding: 15px;\n}\n\n.applicationInputActual{\n\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    border-radius: 3px;\n    /* background-color: gray; */\n    background-color: green;\n    cursor: pointer;\n}\n.applicationInputActual p{\n\n    padding: 20px;\n    margin: 0;\n    color: white;\n}\n\n.ApplicationCTA button{\n    width: 100%;\n    /* background-color: green; */\n    background-color: gold;\n    padding: 20px 24px;\n    font-weight: 900;\n    cursor: pointer;\n    border: none;\n    border-radius: 3px;\n}\n\n.intakeDropDown{\n    position: relative;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    /* overflow: hidden; */\n}\n\n.dropItems{\n    \n    position: absolute;\n    top: 0;\n    /* background-color: yellow; */\n    height: 100%;\n    width: 100%; \n    min-height: 400px;\n    /* overflow: hidden; */\n    /* max-width: 600px; */\n    z-index: 1000;\n\n}\n\n.dropItem{\n\n    background-color: red;\n    margin-top: 20px;\n    z-index: 2000;\n}\n\n.applyresContainer{\n    /* background-color: RED; */\n    padding: 5px;\n}\n\n.resAppCTA button{\n        border: none;\n        padding: 7px;\n        border-radius: 3px;\n        margin-top: 10px;\n        background-color: #003300;\n        color: white;\n        cursor: pointer;\n}\n\n.applyresContainer{\n    width: 100%;\n    padding: 20px 5;\n    border-bottom: 1px solid gray;\n}\n\n.applicationStatusCover{\n    /* background-color: yellow; */\n    display: flex;\n    border-bottom: .5px solid gray;\n    justify-content: space-between;\n    padding-right: 20px;\n    align-items: center;\n}\n\n.applicationStatusCoverCTA button{\n\n        border: none;\n        padding: 8px 12px;\n        background-color: #003300;\n        color: white;\n        border-radius: 3px;\n\n}\n.applicationStatusCoverCTA button:hover{\n\n        border: none;\n        padding: 8px 12px;\n        background-color: #119611;\n        color: white;\n        border-radius: 3px;\n        zoom: 1.01;\n        cursor: pointer;\n\n}\n\n\n/* DROPDOWN CSS */\n\n\n/* ConfirmationCard.css */\n\n.confirmation-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.25); \n    z-index: 1;\n    pointer-events: none; \n  }\n  \n  .confirmation-card {\n    position: relative;\n    z-index: 2;\n    max-width: 400px;\n    width: 100%;\n    transition: top 0.5s ease-in-out;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    \n  }\n  \n  .confirmation-card.visible {\n    top: 30%;\n  }\n  \n  .confirmation-card.hidden {\n    top: -100vh;\n  }\n  \n  .card {\n    background-color: #ffffff;\n    padding: 20px;\n    border-radius: 8px;\n    position: relative;\n  }\n\n  .close-buttonSec {\n  \n    align-items: center;\n  }\n  .close-buttonSec .complete-payment-btn button{\n    width: 300px;\n    align-items: center;\n    background-color: red;\n  }\n  \n  .close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n  }\n  \n  .content {\n    margin-top: 10px;\n  }\n  \n  h2,\n  h3 {\n    color: #333333;\n  }\n  \n  .status {\n    font-weight: bold;\n  }\n  \n  .next-steps h3{\n    color: red;\n  }\n  .next-steps,\n  .assistance {\n    margin-top: 15px;\n  }\n  \n  .complete-payment-btn {\n    background-color: #4caf50;\n    color: white;\n    border: none;\n    padding: 10px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    cursor: pointer;\n    border-radius: 4px;\n  }\n  \n  .email {\n    color: #1565c0;\n  }\n\n\n  @media screen and (max-width: 730px){       \n\n\n          .resptCourse table{\n            /* background-color: red; */\n            width: 400px;\n            /* width: 100%; */\n            text-align: center;\n            /* font-size: 7px; */\n            font-size: 10px;\n          \n          }\n          .resptCourse table button{\n\n                 /* background-color: red; */\n                 font-size: 10px;\n          \n          }\n\n          .applyresContainer{\n            width: 400px;\n            padding: 20px 5;\n            border-bottom: 1px solid gray;\n        }\n        \n\n        .txnHeadingSec{\n          width: 400px;\n          background-color: green;\n          text-align: center;\n          cursor: pointer;\n        }\n\n        .txnHeading {\n          background-color: gold;\n\n          width: 400px;\n          \n        }\n\n        \n      .taglineHomeDashCover{\n        /* background-color:  red; */\n        padding-left: 10px;\n      }\n      .HomeDashCoverStudentNumber{\n        /* background-color:  red; */\n        padding-left: 10px;\n      }\n\n\n      .WalletCover{\n        /* background-color:  red; */\n        padding-left: 0;\n      }\n\n      .ApplicationCardCover{\n        /* background-color: red; */\n        width: 400px;\n        padding:  30px;\n    }\n\n    .BtnSection h3{\n      /* background-color: red; */\n      font-size: 10px;\n    }\n\n  \n  \n   }\n  \n  /* post css */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
